import Lenis from 'lenis';

export const bodyLenis = new Lenis({
    lerp: .1
});

let menuLenis; // Declare menuLenis variable

// Check if menuContainer exists before initializing menuLenis
const menuContainer = document.querySelector('[data-js="menu-slider"] .scroller');
if (menuContainer) {
    menuLenis = new Lenis({
        wrapper: menuContainer,
        lerp: .1,
    });
}

export default function initLenis() {
    function raf(time) {
        bodyLenis.raf(time);
        if (menuLenis) {
            menuLenis.raf(time);
        }
        requestAnimationFrame(raf);
    }

    requestAnimationFrame(raf);

    
    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
        anchor.addEventListener('click', function (e) {
            e.preventDefault();
            
            const targetId = this.getAttribute('href');
            const targetElement = document.querySelector(targetId);
            
            if (targetElement) {
                // Adjust scroll offset (e.g., for a fixed header of 50px)
                const offset = 60; 
                
                bodyLenis.scrollTo(targetElement, {
                    offset: -offset, // Use negative value to scroll above the target
                    behavior: 'smooth', // Optional: add smooth scrolling
                });
            }
        });
    });
}

